/* eslint-disable @typescript-eslint/naming-convention */
import { ExternalChartMetricsEnum } from './external-chart-metrics.enum';
import { SocialSeriesMetricsEnum } from '../../../Social/Intelligence/enums/social-series-metrics.enum';
import { DateAndValueXYChartUnitEnum } from '../../../Common/Charts/enums/date-and-value-x-y-chart-unit.enum';
import { NeoFacetTermFieldApiEnum } from '../../../api/mentions/enum/neo-facet-term-field-api.enum';

export enum ChartMetrics {
    volumeOfMentions = 'VOLUME_OF_MENTIONS',
    audienceReach = 'AUDIENCE_REACH',
    ave = 'AVE',
    domainAuthority = 'DOMAIN_AUTHORITY',
    positiveSentimentPercentage = 'POSITIVE_SENTIMENT_PERCENTAGE',
    neutralSentimentPercentage = 'NEUTRAL_SENTIMENT_PERCENTAGE',
    negativeSentimentPercentage = 'NEGATIVE_SENTIMENT_PERCENTAGE',
    custom = 'CUSTOM',
}

// list of metrics ONLY available to users her have monitoring permission
// to be used in reports to filter out available metrics
export const MentionSeriesMetricsOnly = [
    ChartMetrics.ave,
];

// list of metrics ONLY available to users her have social permission
// to be used in reports to filter out available metrics
export const SocialSeriesMetricsOnly = [
    SocialSeriesMetricsEnum.ENGAGEMENTS,
    SocialSeriesMetricsEnum.ENGAGEMENT_RATE,
    SocialSeriesMetricsEnum.SHARES, // Amplification
    SocialSeriesMetricsEnum.CONVERSATION, // Replies & Quotes -> aka sortFunction
    SocialSeriesMetricsEnum.LIKES, // Applause
    SocialSeriesMetricsEnum.APPLAUSE,
    SocialSeriesMetricsEnum.CONVERSATION,
    SocialSeriesMetricsEnum.AMPLIFICATION,
    SocialSeriesMetricsEnum.VIEWS,
    // todo, add more depening on charts
    SocialSeriesMetricsEnum.ENGAGEMENTS_PER_POST,
];

export type ChartMetricsEnum = ExternalChartMetricsEnum | ChartMetrics | SocialSeriesMetricsEnum;
export const ChartMetricsEnum = {
    ...ChartMetrics,
    ...ExternalChartMetricsEnum,
    ...SocialSeriesMetricsEnum
};

export const chartMetricsToDateAndValueXYChartUnitMap = new Map<ChartMetricsEnum, DateAndValueXYChartUnitEnum>([
    [ChartMetricsEnum.volumeOfMentions, DateAndValueXYChartUnitEnum.NUMBER],
    [ChartMetricsEnum.ave, DateAndValueXYChartUnitEnum.CURRENCY],
    [ChartMetricsEnum.IMPRESSIONS, DateAndValueXYChartUnitEnum.NUMBER],
    [ChartMetricsEnum.ENGAGEMENTS, DateAndValueXYChartUnitEnum.NUMBER],
    [ChartMetricsEnum.ENGAGEMENTS_PER_POST, DateAndValueXYChartUnitEnum.NUMBER],
    [ChartMetricsEnum.ENGAGEMENT_RATE, DateAndValueXYChartUnitEnum.PERCENTAGE],
    [ChartMetricsEnum.APPLAUSE, DateAndValueXYChartUnitEnum.NUMBER],
    [ChartMetricsEnum.AMPLIFICATION, DateAndValueXYChartUnitEnum.NUMBER],
    [ChartMetricsEnum.CONVERSATION, DateAndValueXYChartUnitEnum.NUMBER],
    [ChartMetricsEnum.VIEWS, DateAndValueXYChartUnitEnum.NUMBER],
    [ChartMetricsEnum.positiveSentimentPercentage, DateAndValueXYChartUnitEnum.PERCENTAGE],
    [ChartMetricsEnum.neutralSentimentPercentage, DateAndValueXYChartUnitEnum.PERCENTAGE],
    [ChartMetricsEnum.negativeSentimentPercentage, DateAndValueXYChartUnitEnum.PERCENTAGE],
]);

export const chartMetricsToNeoFacetTermFieldMap = new Map<ChartMetricsEnum, NeoFacetTermFieldApiEnum>([
    [ChartMetricsEnum.volumeOfMentions, NeoFacetTermFieldApiEnum.MENTIONS],
    [ChartMetricsEnum.ave, NeoFacetTermFieldApiEnum.AD_VALUE_USD],
    [ChartMetricsEnum.audienceReach, NeoFacetTermFieldApiEnum.AUDIENCE_REACH],
    [ChartMetricsEnum.ENGAGEMENTS, NeoFacetTermFieldApiEnum.ENGAGEMENT_TOTAL],
    [ChartMetricsEnum.APPLAUSE, NeoFacetTermFieldApiEnum.LIKE],
    [ChartMetricsEnum.AMPLIFICATION, NeoFacetTermFieldApiEnum.SHARE],
    [ChartMetricsEnum.CONVERSATION, NeoFacetTermFieldApiEnum.REPLY],
    [ChartMetricsEnum.IMPRESSIONS, NeoFacetTermFieldApiEnum.AUDIENCE_REACH],
    [ChartMetricsEnum.domainAuthority, NeoFacetTermFieldApiEnum.DOMAIN_AUTHORITY],
    [ChartMetricsEnum.VIEWS, NeoFacetTermFieldApiEnum.VIEW],
]);

export const chartMetricsToCoverageMetricIconsMap = new Map<ChartMetricsEnum, string>([
    [ChartMetricsEnum.volumeOfMentions, 'fa-kit-duotone fa-agpr-posts'],
    [ChartMetricsEnum.audienceReach, 'fa-regular fa-arrows-to-eye'],
    [ChartMetricsEnum.IMPRESSIONS, 'fa-regular fa-arrows-to-eye'],
    [ChartMetricsEnum.ave, 'fa-regular fa-circle-dollar'],
    [ChartMetricsEnum.AVERAGE_DOMAIN_AUTHORITY, 'fa-kit fa-agpr-logo-moz'],
    [ChartMetricsEnum.positiveSentimentPercentage, 'fa-regular fa-face-smile'],
    [ChartMetricsEnum.neutralSentimentPercentage, 'fa-regular fa-face-meh'],
    [ChartMetricsEnum.negativeSentimentPercentage, 'fa-regular fa-face-frown-slight'],
    [ChartMetricsEnum.POSITIVE, 'fa-regular fa-face-smile'],
    [ChartMetricsEnum.NEUTRAL, 'fa-regular fa-face-meh'],
    [ChartMetricsEnum.NEGATIVE, 'fa-regular fa-face-frown-slight'],
    [ChartMetricsEnum.ENGAGEMENTS, 'fa-regular fa-message-heart'],
    [ChartMetricsEnum.ENGAGEMENTS_PER_POST, 'fa-regular fa-message-plus'],
    [ChartMetricsEnum.ENGAGEMENT_RATE, 'fa-regular fa-message-arrow-up-right'],
    [ChartMetricsEnum.APPLAUSE, 'fa-regular fa-hands-clapping'],
    [ChartMetricsEnum.CONVERSATION, 'fa-regular fa-comments'],
    [ChartMetricsEnum.AMPLIFICATION, 'fa-regular fa-bullhorn'],
    [ChartMetricsEnum.VIEWS, 'fa-regular fa-eye'],
]);
